import script from "./CustomerDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDetails.vue?vue&type=style&index=0&id=e1895eb8&scoped=true&lang=css"

import exportComponent from "/Users/zane/Dev/ionic-spirit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1895eb8"]])

export default __exports__